var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobSchedule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 17.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 17.5,
    stroke: "#E5E7DF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9932 10.5V12H20.9834V10.5H22.4805V12C25.2653 12 25.4756 12.4698 25.4756 14.0312C25.4756 14.5228 25.5 23.5202 25.5 23.8203C25.5 24.7338 24.9007 25.5 24.0732 25.5H12.0928C11.2661 25.5 10.5479 24.6483 10.5479 23.8203L10.5 13.5C10.5 12.675 11.1744 12 11.998 12H13.4951V10.5H14.9932ZM11.998 18V23.25C11.998 23.6639 12.3329 23.9998 12.7461 24H23.2295C23.6413 24 23.9785 23.6625 23.9785 23.25V18H11.998ZM12.7246 13.5C12.3233 13.5 11.998 13.8265 11.998 14.2285V16.5H23.9785V14.25C23.9785 13.836 23.6428 13.5 23.2295 13.5H22.4805V15H20.9834V13.5H14.9932V15H13.4951V13.5H12.7246Z",
    fill: "#8CAEB4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobSchedule);
export default __webpack_public_path__ + "static/media/job-schedule.91368145ead239c0b316ecf2b0f54293.svg";
export { ForwardRef as ReactComponent };